import React from "react";
import { BaseModal, IModalInstance } from "@whatslly/ui-components/modals";
import styles from "./EmojiPickerModal.module.scss";
import { useTranslation } from "react-i18next";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";

export const EmojiPickerModal: React.FC<IModalInstance<{ result: boolean }> & { onEmojiSelect: (emo: { native: string }) => void }> = ({
  closeModal,
  onEmojiSelect,
}) => {
  const { i18n } = useTranslation();
  return (
    <BaseModal
      backdropClassName={styles.backdrop}
      testId="emoji-picker-modal"
      closeModal={closeModal}
      closeOnEscape={true}
      closeOnClickOutside={true}
      className={styles.modal}
    >
      <div className={styles.main}>
        <Picker
          locale={i18n.language ?? `en`}
          data={data}
          onEmojiSelect={(emo: { native: string; keywords: string[] }) => {
            onEmojiSelect(emo);
            closeModal();
          }}
        />
      </div>
    </BaseModal>
  );
};
